const DEV_TOOLS_COOKIE = 'show-devtools';
const COOKIE_MAX_AGE = 31536000; // 1 year

export function readCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function writeCookie(name, value, maxAge = COOKIE_MAX_AGE) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function clearCookie(name) {
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
}

export function isDevToolsEnabled() {
  const params = new URLSearchParams(window.location.search);
  const param = params.get(DEV_TOOLS_COOKIE);
  if (param === 'false') {
    clearCookie(DEV_TOOLS_COOKIE);
    return false;
  }
  if (param === 'true') {
    if (readCookie(DEV_TOOLS_COOKIE) !== 'true') {
      writeCookie(DEV_TOOLS_COOKIE, 'true');
    }
    return true;
  }
  return readCookie(DEV_TOOLS_COOKIE) === 'true';
}

export function enableDevTools() {
  writeCookie(DEV_TOOLS_COOKIE, 'true');
}

export function disableDevTools() {
  clearCookie(DEV_TOOLS_COOKIE);
}

export { DEV_TOOLS_COOKIE };
